import React, { useState } from "react";
import {
  AiOutlineArrowRight,
  AiOutlineArrowDown,
  AiFillCaretRight,
  AiOutlineArrowUp,
} from "react-icons/ai";

const IndoDairyDevelopmentSchemeAccordion = ({ question, answerType, answer }) => {
  const [show, setShow] = useState(false);

  const renderAnswer = () => {
    if (answerType === "text") {
      return answer.map((text, index) => (
        <p key={index} style={{ paddingLeft: "80px", paddingRight: "80px", marginBottom: "15px" }}>
          {text}
        </p>
      ));
    }

    if (answerType === "mixed") {
      return (
        <div style={{ paddingLeft: "80px", paddingRight: "80px" }}>
          <p>{answer.intro}</p>
          {answer.desc && <p className="fw-medium">{answer.desc}</p>}
          <ul style={{ listStyle: "none", paddingLeft: 0, paddingTop: "16px" }}>
            {answer.list.map((item, index) => (
              <li key={index} className="d-flex align-items-start mb-2">
                <AiFillCaretRight size={15} className="me-2 mt-1" />
                <p className="m-0">{item}</p>
              </li>
            ))}
          </ul>
        </div>
      );
    }

    return null;
  };

  return (
    <li className={`accordion block ${show ? "active-block" : ""}`}>
      <div className={`acc-btn ${show ? "active" : ""}`} onClick={() => setShow(!show)}>
        <div className="icon-outer">
          {show ? <AiOutlineArrowRight /> : <AiOutlineArrowRight />}
        </div>
        <h3>{question}</h3>
      </div>

      {show && (
        <div className="acc-content current">
          {renderAnswer()}
        </div>
      )}
    </li>
  );
};

export default IndoDairyDevelopmentSchemeAccordion;